import log from "loglevel";
import React from "react";
import environment, { EnvironmentProvider } from "../../services/EnvironmentProvider/EnvironmentProvider";
import I18nProvider from "../../services/I18nProvider/I18nProvider";
import localStorageProvider, {LocalStorageProvider} from "../../services/LocalStorageProvider/LocalStorageProvider";
import requestProvider, { RequestProvider } from "../../services/RequestProvider/RequestProvider";
import logger from "../../services/Logger/Logger";
import utilityProvider, { UtilityProvider } from "../../services/UtilityProvider/UtilityProvider";
import SessionStorageProvider from "../../services/SessionStorageProvider/SessionStorageProvider";
import loginProvider, { LoginProvider } from "../../services/LoginProvider/LoginProvider";
import globalStates, { GlobalStates } from "../../services/GlobalStates/GlobalStates";
export default interface GlobalContextType {
    localStorageProvider: LocalStorageProvider;
    sessionStorageProvider: SessionStorageProvider;
    environment: EnvironmentProvider;
    logger: log.RootLogger;
    requestProvider: RequestProvider;
    i18nProvider: I18nProvider;
    utilityProvider: UtilityProvider;
    loginProvider: LoginProvider;
    globalStates: GlobalStates;
}

export const GlobalContext = React.createContext<GlobalContextType>({
    localStorageProvider: localStorageProvider,
    sessionStorageProvider: new SessionStorageProvider({}),
    environment: environment,
    logger: logger,
    requestProvider: requestProvider,
    i18nProvider: new I18nProvider({}),
    utilityProvider: utilityProvider,
    loginProvider: loginProvider,
    globalStates: globalStates,
});